import { render, staticRenderFns } from "./SucursalInventarios.vue?vue&type=template&id=78fc248c&scoped=true&"
import script from "./SucursalInventarios.vue?vue&type=script&lang=js&"
export * from "./SucursalInventarios.vue?vue&type=script&lang=js&"
import style0 from "./SucursalInventarios.vue?vue&type=style&index=0&id=78fc248c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fc248c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDatePicker,VDivider,VIcon,VMenu,VRow})
